import AfiliadoService from '../../services/AfiliadoService'

const state = {
  afiliados: [],
  afiliado: null,
  totalItems: 0,
  currentPage: 1,
  itemsPerPage: 50
}

const getters = {
  afiliados: state => state.afiliados,
  afiliado: state => state.afiliado,
  totalItems: state => state.totalItems,
  currentPage: state => state.currentPage,
  itemsPerPage: state => state.itemsPerPage
}

const actions = {
  async fetchAfiliados({ commit, state }, { page = 1, filters = {} }) {
    try {
      const response = await AfiliadoService.getAfiliados(page, state.itemsPerPage, filters)
      console.log("----------", response);
      commit('setAfiliados', response.data.data)
      commit('setTotalItems', response.data.total || 0)
      commit('setCurrentPage', page)
      return response
    } catch (error) {
      console.error('Error fetching afiliados:', error)
      throw error
    }
  },

  async fetchAfiliado({ commit }, id) {
    try {
      const response = await AfiliadoService.getAfiliado(id)
      commit('setAfiliado', response.data.data)
      return response
    } catch (error) {
      throw error
    }
  },

  async createAfiliado({ commit }, afiliado) {
    try {
      const response = await AfiliadoService.createAfiliado(afiliado)
      return response
    } catch (error) {
      throw error
    }
  },

  async updateAfiliado({ commit }, { id, afiliado }) {
    try {
      const response = await AfiliadoService.updateAfiliado(id, afiliado)
      return response
    } catch (error) {
      throw error
    }
  },

  async deleteAfiliado({ commit }, id) {
    try {
      const response = await AfiliadoService.deleteAfiliado(id)
      return response
    } catch (error) {
      throw error
    }
  },

  async generarCarnet({ commit }, id) {
    try {
      const response = await AfiliadoService.generarCarnet(id)
      return response
    } catch (error) {
      console.error('Error in store generarCarnet:', error)
      throw error
    }
  },

  async generarCarnetsMasivos({ commit }, ids) {
    try {
      const response = await AfiliadoService.generarCarnetsMasivos(ids)
      return response
    } catch (error) {
      console.error('Error in store generarCarnetsMasivos:', error)
      throw error
    }
  },

  async exportarListado({ commit }, { formato, filtros }) {
    try {
      const response = await AfiliadoService.exportarListado(formato, filtros)
      return response
    } catch (error) {
      throw error
    }
  },
  
  async generarFicheroSEPAMasivo({ commit }, { ids, datos }) {
    try {
      const response = await AfiliadoService.generarFicheroSEPAMasivo(ids, datos)
      return response
    } catch (error) {
      console.error('Error in store generarFicheroSEPAMasivo:', error)
      throw error
    }
  },

  async generarQRCarnet({ commit }, id) {
    try {
      const response = await AfiliadoService.generarQRCarnet(id)
      return response
    } catch (error) {
      console.error('Error in store generarQRCarnet:', error)
      throw error
    }
  },

  async generarQRCarnetsMasivos({ commit }, ids) {
    try {
      const response = await AfiliadoService.generarQRCarnetsMasivos(ids)
      return response
    } catch (error) {
      console.error('Error in store generarQRCarnetsMasivos:', error)
      throw error
    }
  },

  async descargarPlantillaCargaMasiva({ commit }) {
    try {
      const response = await AfiliadoService.descargarPlantillaCargaMasiva()
      return response
    } catch (error) {
      console.error('Error in store descargarPlantillaCargaMasiva:', error)
      throw error
    }
  },

  async cargaMasivaAfiliados({ commit }, formData) {
    try {
      const response = await AfiliadoService.cargaMasivaAfiliados(formData)
      return response
    } catch (error) {
      console.error('Error in store cargaMasivaAfiliados:', error)
      throw error
    }
  },

  async exportarWalletUrls({ commit }, ids) {
    try {
      const response = await AfiliadoService.exportarWalletUrls(ids)
      return response
    } catch (error) {
      console.error('Error in store exportarWalletUrls:', error)
      throw error
    }
  },

  async enviarCarnetEmail({ commit }, { id, email }) {
    try {
      const response = await AfiliadoService.enviarCarnetEmail(id, email)
      return response
    } catch (error) {
      console.error('Error in store enviarCarnetEmail:', error)
      throw error
    }
  }
}

const mutations = {
  setAfiliados(state, afiliados) {
    state.afiliados = afiliados
  },
  setAfiliado(state, afiliado) {
    state.afiliado = afiliado
  },
  setTotalItems(state, total) {
    state.totalItems = total
  },
  setCurrentPage(state, page) {
    state.currentPage = page
  },
  setItemsPerPage(state, itemsPerPage) {
    state.itemsPerPage = itemsPerPage
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}